import * as jwt_decode from "jwt-decode";
import { SESSION_TOKEN_STORAGE_NAME } from "../Constants";
import ServerConnector from "../utils/ServerConnector";

export const registerUser = async (data) => {
  try {
    const response = await ServerConnector.post("/auth/register", data);
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

export const sendPasswordResetToken = async (data) => {
  try {
    const response = await ServerConnector.post(
      "/auth/reset-password/sendPassResetToken",
      data
    );
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

export const verifyTokenAndChangePassword = async (data) => {
  try {
    const response = await ServerConnector.post(
      "/auth/reset-password/verifyTokenAndChangePassword",
      data
    );
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

export const loginUser = async (data) => {
  try {
    let response = await ServerConnector.post("/auth/login", data);

    if (response.data.success) {
      const { authToken } = response.data;

      localStorage.setItem(SESSION_TOKEN_STORAGE_NAME, authToken);

      const decodedToken = jwt_decode.jwtDecode(authToken);
      response.decodedToken = decodedToken;
      return response;
    }
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

export const verifyUser = async () => {
  try {
    const response = await ServerConnector.post("/auth/verify");
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

export const reloadAuthToken = () => {
  ServerConnector.post("/auth/reload-token")
    .then((response) => {
      if (response.data.success) {
        localStorage.removeItem(SESSION_TOKEN_STORAGE_NAME);

        const { authToken } = response.data;
        localStorage.setItem(SESSION_TOKEN_STORAGE_NAME, authToken);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
